import React, { useEffect, useState } from 'react';
import Image from '../../../../../../common/component/LazyImage';
// import omniture from '../../tracker/omniture';

const TEXT_TYPE = 'TEXT';
const LINK_TYPE = 'LINK';
const IMAGE_DIM = [
  [135, 160],
  [135, 80],
];

const omniture = {
  captureOmnitureClick: () => {},
};

const SubMenuBox = ({ menuDetail, activeMenu }) => {
  const [subMenu, setSubMenu] = useState(null);
  const [menuTextList, setMenuTextList] = useState([]);
  const [menuImageList, setMenuImageList] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState(null);

  const getMenusDetail = menus => {
    const textList = [];
    const imageList = [];
    menus.map((menu, order) => {
      if ([TEXT_TYPE, LINK_TYPE].indexOf(menu.type) >= 0) {
        return textList.push({ ...menu, order });
      }
      return imageList.push({ ...menu, order });
    });
    return [textList, imageList];
  };

  const changeSubMenu = (subMenus, index, order) => {
    const [textList, imageList] = getMenusDetail(subMenus);
    setSubMenu(textList);
    setSelectedMenu({ index, order });
    setMenuImageList(imageList);
  };

  useEffect(() => {
    const [textList, imageList] = getMenusDetail(menuDetail);
    setMenuTextList(textList);

    if (textList?.length && textList[0].subMenu) {
      changeSubMenu(textList[0].subMenu, 0, textList[0].order);
    } else {
      setMenuImageList(imageList);
      setSubMenu(null);
      setSelectedMenu(null);
    }
  }, [menuDetail]);

  const openLink = ({ deeplink, type, name, order }, isSecondLevel) => {
    if (deeplink) {
      let omnitureStr = `Menu_${activeMenu}|`;
      if (!isSecondLevel && selectedMenu) {
        omnitureStr += `${selectedMenu?.order || 0 + 1}|`;
      }
      omnitureStr += `${order + 1}_${name}_${type}`;
      omniture.captureOmnitureClick(omnitureStr);
      window.open(deeplink);
    }
  };

  const isRowImage = menuImageList.length > 3 ? 1 : 0;
  const imageSize = IMAGE_DIM[isRowImage].join(':');

  const renderSubMenuLink = (list, starting, ending) => {
    const comp = [];
    for (let index = starting; index < ending && index < list.length; index++) {
      const menu = list[index];
      comp.push(
        <li
          key={menu.name}
          onClick={() => {
            openLink(menu, false);
          }}
          className={menu.deeplink ? 'deeplink' : 'nodeeplink'}
        >
          <a>{menu.name}</a>
        </li>
      );
    }
    if (comp.length) {
      return <ul className="renderDeepLinks1">{comp}</ul>;
    }
    return null;
  };

  const subMenuSeprator = subMenu?.length > 12 ? Math.ceil(subMenu.length / 2) : 6;
  return (
    <div className="makeFlex">
      <div className="makeFlex flexOne">
        <ul className="renderLinks">
          {menuTextList.map((menu, index) => (
            <li
              key={menu.name}
              onMouseEnter={() => {
                changeSubMenu(menu.subMenu || [], index, menu.order);
              }}
              className={selectedMenu?.index === index ? 'active' : ''}
              onClick={() => {
                openLink(menu, true);
              }}
            >
              <a>
                <span>{menu.name}</span>
              </a>
            </li>
          ))}
        </ul>
        {subMenu && renderSubMenuLink(subMenu, 0, subMenuSeprator)}
        {subMenu && renderSubMenuLink(subMenu, subMenuSeprator, subMenuSeprator * 2)}
      </div>
      <ul className={`renderImages ${isRowImage ? 'grid2' : ''}`}>
        {menuImageList.map(menu => (
          <li
            key={menu.name}
            onClick={() => {
              openLink(menu, false);
            }}
            className={menu.deeplink ? 'pointer' : ''}
          >
            <div className="imgWrap">
              <Image
                width={IMAGE_DIM[isRowImage][0]}
                height={IMAGE_DIM[isRowImage][1]}
                src={`${menu.image}?crop=${imageSize}&downsize=${imageSize})`}
              />
            </div>
            <div className="makeFlex column appendTop10">
              <p className="font12 latoBlack blackText capText">{menu.name}</p>
              {menu.price && (
                <p className="font11 latoBlack makeFlex hrtlCenter appendTop2">
                  {menu.price}
                  <span className="latoRegular greyText">{menu.priceTag}</span>
                </p>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SubMenuBox;
